import * as React from 'react';
import {
  AppBarComponent,
  AppBarItem,
  AppBarLink,
  AppBarNavLink,
} from '@manulife-web/shared-module';
import { useIntl } from '@leagueplatform/locales';
import { Link } from 'react-router-dom';
import { Button, ParagraphText } from '@leagueplatform/genesis-core';

import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { UserDropdown } from './user-dropdown/user-dropdown.component';
import { LinkType, NavLink, useNavLinksList } from './use-nav-links-list.hook';

const APP_NAV_DEFAULT_HEIGHT = 8 * 7; // 56px – 7 lines on the Genesis 8px grid

export const AppNavBarComponent = () => {
  const { navLinks } = useNavLinksList();
  const { formatMessage } = useIntl();
  const sendNavBarAnalyticsEvent = (action: string) => () =>
    trackAnalyticsEvent(EVENT_NAME.NAVIGATION_TAB_CLICKED, {
      screen_name: 'Navigation Bar',
      detail: action,
    });

  const navLinkWrapper = (navLink: NavLink) => {
    switch (navLink.type) {
      case LinkType.LINK:
        return (
          <AppBarLink
            as={Link}
            to={navLink.to}
            key={navLink.message_id}
            onClick={sendNavBarAnalyticsEvent(navLink.message_id)}
          >
            {formatMessage({ id: navLink.message_id })}
          </AppBarLink>
        );
      case LinkType.NAV:
        return (
          <AppBarNavLink
            to={navLink.to}
            key={navLink.message_id}
            onClick={sendNavBarAnalyticsEvent(navLink.message_id)}
          >
            {formatMessage({ id: navLink.message_id })}
          </AppBarNavLink>
        );
      default:
        throw new Error('invalid link type');
    }
  };

  return (
    <AppBarComponent navHeight={APP_NAV_DEFAULT_HEIGHT}>
      {/* Spacer */}
      <AppBarItem
        css={{
          flexGrow: 2,
          '@mobile': {
            flexGrow: 0,
          },
          '@mobileLandscape': {
            flexGrow: 0,
          },
          '@tablet': {
            flexGrow: 0,
          },
        }}
        aria-hidden="true"
      />
      {/* App Nav Home & Capability Areas */}
      {navLinks.map((navLink) => navLinkWrapper(navLink))}

      {/* Spacer */}
      <AppBarItem
        css={{
          flexGrow: 30,
          '@mobile': {
            flexGrow: 1,
          },
          '@mobileLandscape': {
            flexGrow: 1,
          },
          '@tablet': {
            flexGrow: 1,
          },
        }}
      />

      {/* App Nav User Dropdown */}
      <AppBarItem>
        <UserDropdown />
      </AppBarItem>

      <AppBarItem>
        <Button
          type="button"
          priority="secondary"
          onClick={() => {
            const currentLang = document.documentElement.lang;
            document.documentElement.lang = currentLang === 'fr' ? 'en' : 'fr';
          }}
        >
          Toggle lang
        </Button>
        <ParagraphText css={{ marginLeft: '$half' }}>
          Current Lang: {document.documentElement.lang}
        </ParagraphText>
      </AppBarItem>
      {/* Spacer */}
      <AppBarItem
        css={{
          flexGrow: 2,
          '@mobile': {
            flexGrow: 0,
          },
          '@mobileLandscape': {
            flexGrow: 0,
          },
          '@tablet': {
            flexGrow: 0,
          },
        }}
        aria-hidden="true"
      />
    </AppBarComponent>
  );
};
